<template>
  <b-container fluid class="bg-white">
    <div class="row">
      <div class="col-lg-12" v-if="clonedItems.length > 0">
        <ProjectTrackerList
          :loading="loading"
          :metas="metas"
          :listItems="items"
          :showProjectFilter="clonedItems.length > 0" />
      </div>
      <div class="col-lg-12 text-center" v-else>
        <h5>
          <b-badge variant="secondary" v-if="loading">
            Loading, Please wait...
          </b-badge>
          <b-badge variant="secondary" v-else>
            There isn't any active projects to show here.
          </b-badge>
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
  </b-container>
</template>

<script>
import { format as dateFormat } from 'date-fns'
import Services from '../../services/main.service.vue'
import ProjectTrackerList from './projects-components/ProjectTrackerList.vue'

export default {
  name: 'ProjectsTrackerComponent',
  components: {
    ProjectTrackerList
  },
  data() {
    return {
      loading: false,
      showFeeCheckbox: false,
      clonedItems: [], // using for filtering
      items: [],
      metas: {}
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    Pager() {
      return this.Store.projectsTrackerPager
    },
    CacheControl() {
      return this.Store.projectsTrackerCache
    },
    HasAdminPerm() {
      return this.$store.state.user.hasAdminPrivileges
    }
  },
  mounted() {
    this.getProjectsMetas()
    this.fetchData()
    this.$root.$on('tab_projects_tracker_refresh', this.fetchData)
    this.$root.$on('update_project_tracker', this.updateProject)
  },
  methods: {
    async getProjectsMetas() {
      const { status, data } = await Services.Projects.Admin.getMetas()
      if (status === 200) {
        this.metas = data.content.metas
      }
    },
    async fetchData() {
      this.loading = true
      // GET METAS
      await this.getProjectsMetas()
      this.items = []
      this.clonedItems = []
      // GET PROJECTS
      const Projects = await Services.Projects.Admin.getProjectsTracker(
        this.Pager,
        this.CacheControl
      )
      if (Projects.status == 200) {
        this.$store.commit(
          'updProjectsTrackerPager',
          Projects.data.content.info
        )
        const systemProjects = Projects.data.content.list
          .filter((itm) => itm.meta.system)
          .map((itm) => {
            itm.source = itm.meta?.partner ?? ''
            itm._new = false
            itm._edit = false
            return itm
          })
        Projects.data.content.list
          // .filter((itm) => !itm.meta.system)
          .forEach((itm) => {
            itm.source = itm.type === 'project' ? '' : itm.meta?.partner ?? ''
            itm.status = itm.status.toUpperCase() === 'LIVE'
            itm._new = false
            itm._edit = false
            this.items.push(itm)
          })
        this.clonedItems = [...this.items]
      }
      this.$store.commit('setProjectsTrackerCache', 'cache')
      this.loading = false
    },
    async ForceUpdate() {
      this.$store.commit('setProjectsTrackerCache', 'no-cache')
      await this.fetchData()
    },
    searchProject(q = null) {
      if (q && q.trim().length) {
        this.items = this.clonedItems.filter((itm) => {
          const qRegEx = new RegExp(`^${q.trim()}`, 'i')
          const title = qRegEx.test(itm.title.trim())
          const projectCode = qRegEx.test(itm.code.trim())
          return title || projectCode || q === itm.uid
        })
      } else {
        this.items = this.clonedItems.filter((itm) => {
          if (this.filteredBy) {
            return itm.type.toUpperCase() === this.filteredBy.toUpperCase()
          }
        })
      }
    },
    async addNew(type = 'PROJECT') {
      if (this.items.findIndex((itm) => itm._new) > -1) return
      const defaultProject = {
        type,
        code: null,
        title: '',
        client: null,
        partners: null,
        meta: {
          color: '#000',
          partner: null,
          projectName: '',
          ems: ''
        },
        status: 'CLOSED',
        sector: 'OTHER',
        todos: 'NTD',
        notes: '',
        totalassociates: 0,
        totalanalysts: 0,
        budget: 0,
        totalFees: 0,
        active: false,
        created: dateFormat(new Date(), 'yyyy-MM-dd'),
        deadline: null,
        _new: true,
        _edit: true
      }
      this.items.unshift(defaultProject)
    },
    async saveNew() {
      try {
        const toCreate = this.items.find((itm) => itm._new)
        if (toCreate?.length == 0 || typeof toCreate == 'undefined') return
        const { status } = await Services.Projects.Admin.create(toCreate)
        if (status == 200) {
          this.items = this.items.map((itm) => {
            itm._new = false
            itm._edit = false
            return itm
          })
          this.$bvToast.toast('Project created', {
            title: 'Success',
            variant: 'success',
            solid: true
          })
        }
      } catch (Exception) {
        this.items = this.items.splice(1)
        console.log(Exception?.response ?? Exception)
      }
    },
    async updateProject(project) {
      try {
        if (project._new) {
          await this.saveNew(project.type)
          return
        }
        await Services.Projects.Admin.update(project.uid, project)
      } catch (Exception) {
        throw Exception
      }
    }
  }
}
</script>

<style>
.cost-details-btn {
  font-size: 9pt !important;
  font-weight: bold;
  color: #6cf;
}
.lizard-column-fees {
  font-family: 'Courier New', Courier, monospace !important;
  font-size: 12px !important;
  font-weight: 100 !important;
}
.lizard-column-fees-disabled {
  color: #999;
}
/* .lizard-scroll and .lizard-candesic-table are styled centrally in
   src/styles/logs.css. */
</style>

<style scoped>
.lizard-activity-list {
  font-size: 12px !important;
  color: #666;
  font-weight: bold !important;
}
.lizard-column-index {
  text-align: center !important;
}
.lizard-form-empty-col {
  min-height: 20px !important;
}
.lizard-reports-stats li {
  display: inline-block;
}
.lizard-hourly-rate-input {
  text-align: center;
  width: 60px;
  max-width: 60px;
}
.lizard-date-input {
  text-align: center;
  width: 90px;
  max-width: 90px;
}
.header-msg {
  color: #666;
  font-weight: bold !important;
}
label {
  color: #666;
  line-height: 40px !important;
  font-weight: bold !important;
  font-size: 12px !important;
}
.txt {
  color: #666;
  font-weight: bold !important;
  font-size: 12px !important;
}
</style>
